import { render, staticRenderFns } from "./PlayerSkills.vue?vue&type=template&id=8b86f29c"
import script from "./PlayerSkills.vue?vue&type=script&lang=js"
export * from "./PlayerSkills.vue?vue&type=script&lang=js"
import style0 from "./PlayerSkills.vue?vue&type=style&index=0&id=8b86f29c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports